import axios from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { useCurrentUser } from '@hotjar/user';
import { getApiHost } from '@hotjar/common';
import type { ActiveSites } from './model';

export const SITE_ACCESS_QUERY_KEY = 'site-access';

const getSiteAccessData = async (userId: number) => {
  const response = await axios.get(`${getApiHost()}/api/v1/users/${userId}/site-access`);

  return response.data.active_sites ?? [];
};

export const useSiteAccess = (): UseQueryResult<ActiveSites> => {
  const { data: user } = useCurrentUser();

  const userId = user?.id;

  return useQuery([SITE_ACCESS_QUERY_KEY, userId], () => getSiteAccessData(userId as number), {
    enabled: userId !== undefined,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });
};
